import Confetti from 'react-confetti';
import useWindowSize from 'react-use/lib/useWindowSize';
import Typography from '@mui/material/Typography';

export default function PlanPaymentSuccess() {
  const { width, height } = useWindowSize();

  return (
    <>
      <Typography
        component="h2"
        variant="h4"
        gutterBottom
        className="tw-font-semibold"
      >
        Congratulations, your blog has been upgraded!
      </Typography>
      <Confetti width={width} height={height} recycle={false} />
    </>
  );
}
